<template lang="pug">
feathers-vuex-find(service="vw-user-verification" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
  v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
    v-card-title
      div
        export-reports
        | Pending Signup Users
        
      v-spacer
      v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
    v-data-table(
      :headers="headers"
      :loading="isFindPending"
      :items="isFindPending ? [] : desserts"
      :options.sync="pagination"
      :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
      :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
      loading-text="Fetching Data..."
    )
      template(v-slot:item.name_email_address="{ item }")
        div(style="font-weight: bold;") {{ item.fname }} {{ item.lname }}
        div
          i(style="color: #9d9d9d;") {{ item.email }}

      template(v-slot:item.createdAt="{ item }")
        div {{ item.createdAt | dateFormat }}

      template(v-slot:item.status="{ item }")
        v-chip(v-if="item.status === 'PENDING'" color="grey" small style="color: #ffffff;") {{ item.status }}
        v-chip(v-if="item.status === 'VERIFIED'" color="green" small style="color: #ffffff;") {{ item.status }}

      template(v-slot:item.actions="{ item }")
        div(v-if="item.status === 'PENDING'")
            a(href="javascript:void(0);" @click="openLink(item.id)" style="color: green; text-decoration: none;") Approve User
            
        div(v-else) ---

</template>

<script>
import moment from 'moment';
import ExportReports from './components/ExportReports.vue';

export default {
  data() {
    return {
      searchUser: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          width: 50,
          value: 'id'
        },
        {
          text: 'Name / Email Address',
          align: 'start',
          sortable: false,
          value: 'name_email_address'
        },
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status'
        },
        // {
        //   text: 'Title',
        //   align: 'start',
        //   sortable: false,
        //   value: 'title'
        // },
        // {
        //   text: 'Audio',
        //   align: 'start',
        //   sortable: false,
        //   value: 'audio'
        // },
        {
          text: 'Date Added',
          align: 'end',
          sortable: false,
          value: 'createdAt'
        },
        {
          text: 'Actions',
          align: 'end',
          sortable: false,
          value: 'actions'
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true]
      },
      query: {},
    };
  },
  filters: {
    dateFormat(date) {
      if (date) {
        return moment(date).format('lll');
      }

      return 'n/a';
    },
    status(status) {
      switch (status) {
        case 0: return 'Inactive';
        case 1: return 'Active';
      }
    }
  },
  computed: {
    extendedQuery() {
      if (this.user) {
        return {
          // id: { $nin: [this.user.id] }
        };
      }
      return null;
    },
    searchQuery() {
      if (this.searchUser) {
        return {
          $or: [
            { fname: { $like: `%${this.searchUser}%` } },
            { lname: { $like: `%${this.searchUser}%` } },
            { email: { $like: `%${this.searchUser}%` } },
          ]
        };
      }
      return null;
    },
    searchDataQuery() {
      if (this.searchUser) {
        return {
          $or: [
            { fname: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
            { lname: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
            { email: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
          ]
        };
      }
      return null;
    },
    sortingQuery() {
      if (this.pagination.sortBy.length !== 0) {
        const $sort = {};
        this.pagination.sortBy.map((item, index) => {
          switch (item) {
            case 'fullname':
              $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
              $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
              break;
            default:
              $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
          }

        });
        return { $sort };
      }
      return null;
    },
    dataQuery() {
      return {
        ...this.query,
        ...this.extendedQuery,
        ...this.searchDataQuery,
        $limit: this.pagination.itemsPerPage,
        $skip: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        ...this.sortingQuery
      };
    },
    fetchQuery() {
      return Object.assign({}, {
        ...this.query,
        ...this.extendedQuery,
        // $populate: true
      }, {
        ...this.searchQuery,
        $limit: this.pagination.itemsPerPage,
        $skip: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        ...this.sortingQuery
      });
    },
  },
  methods: {
    openLink(id) {

    },
    escapeRegex(string) {
      return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    },
  },
  components: {
    ExportReports
  }
}
</script>